import constants from "../assets/constants.js";

export const DEFAULT_HARNESS_USER = {
  uiLabel: "Anonymous",
  displayName: "",
  languageCode: "en-US",
  origin: constants.botpressConversationOriginEnums.harness,
};

export const getHarnessUsers = botODM => {
  const profiles = botODM?.omniData?.userProfiles;
  return Array.isArray(profiles) && profiles.length > 0 ? profiles : [DEFAULT_HARNESS_USER];
};

export const getDefaultUserIndex = profiles => {
  const defaultIndex = profiles.findIndex(profile => profile?.defaultUser === true);
  return defaultIndex >= 0 ? defaultIndex : 0;
};

export const toUserData = ({ uiLabel, defaultUser, ...rest }) => rest;

export const getHarnessUserLabel = (harnessUser, index) =>
  harnessUser?.uiLabel || harnessUser?.displayName || `User ${index + 1}`;
